{
  "tabs": {
    "lintTriage": "Triage du lint",
    "testFailures": "Échecs des tests",
    "playwrightTests": "Tests Playwright"
  },
  "fixWithClaudeDialog": {
    "title": "Corriger avec Claude - {{fileName}}",
    "runningInBackground": "Exécution en arrière-plan (cette fenêtre peut être fermée)",
    "startingClaude": "Démarrage de Claude...",
    "fileChangesAccordion": "Modifs fichiers (git diff)",
    "noChangesDetected": "Aucune modification détectée",
    "status": {
      "success": "✅ Correction effectuée avec succès !",
      "cancelled": "⚠️ Correction annulée",
      "error": "❌ Échec (voir résultat ci-dessus)"
    },
    "buttons": {
      "cancel": "Annuler",
      "clear": "Effacer",
      "close": "Fermer"
    }
  },
  "playwrightTests": {
    "title": "Tests Playwright",
    "loading": "Chargement des tests Playwright...",
    "testCount": "{{count}} tests · Env. {{duration}}",
    "buttons": {
      "retry": "Réessai",
      "runningTests": "Exécution des tests...",
      "runAllTests": "Tout tester"
    },
    "alerts": {
      "noTestsFound": "Aucun résultat de test Playwright trouvé. Cliquez sur « Exécuter tous les tests » pour lancer la suite de tests.",
      "runningTests": "Exécution des tests Playwright... Cela peut prendre quelques minutes."
    },
    "execution": {
      "started": "Exécution du test démarrée ({{processId}})",
      "completed": "Exécution du test terminée avec le code {{code}}"
    }
  },
  "fileCard": {
    "errorCounts": {
      "eslint": "ESLint",
      "typescript": "TypeScript",
      "total": "total"
    },
    "buttons": {
      "viewErrors": "Voir les erreurs",
      "copyAll": "Tout copier pour Claude",
      "fixAllWithClaude": "Tout corriger avec Claude",
      "viewProgress": "Voir la progression...",
      "fixed": "Corrigé ✓",
      "fixFailed": "Échec correction ✗"
    }
  },
  "fileErrorsView": {
    "buttons": {
      "backToFiles": "Retour aux fichiers",
      "copyAllErrors": "Copier les {{count}} erreurs",
      "openInVSCode": "Ouvrir dans VSCode",
      "copyIndividual": "Copier l'individu"
    },
    "errorCounts": {
      "eslint": "ESLint",
      "typescript": "TypeScript",
      "total": "total",
      "line": "Ligne {{number}}"
    },
    "snackbar": {
      "copiedAll": "Tous les {{count}} erreurs copiées pour Claude !",
      "copiedLine": "Erreur copiée depuis la ligne {{line}}"
    }
  },
  "playwrightTestDetail": {
    "buttons": {
      "backToTests": "Retour aux tests",
      "viewScreenshots": "Voir les captures d'écran ({{count}})",
      "viewVideos": "Voir les vidéos ({{count}})",
      "updateSnapshots": "Actualiser instantanés",
      "updating": "Mise à jour...",
      "fixWithClaude": "Corriger avec Claude"
    },
    "labels": {
      "errorMessage": "Message d'erreur :"
    },
    "messages": {
      "testPassed": "Ce test a réussi !",
      "snapshotsUpdated": "Instantanés mis à jour avec succès !",
      "snapshotsFailed": "Échec de la mise à jour des snapshots. Consultez la console pour plus de détails.",
      "error": "Erreur : {{message}}",
      "claudeComingSoon": "L'intégration Claude fix arrive bientôt !"
    }
  }
}
